import React, { useContext } from 'react'
import { DecisionBox, Loader } from 'src/component'
import VisibilityContext from 'src/provider/state-manager/visibilityProvider'
import {Notifier} from 'react-pop-notifier';

export const StatusHandler: React.FC<any> = () => {
    const { visibility: {isLoading, decision} } = useContext(VisibilityContext)

    return (
        <>
            { isLoading && <Loader /> }
            <Notifier />
            { decision.status &&
                <DecisionBox 
                    yesBtnText={decision.yesBtnText}
                    noBtnTxt={decision.cancelBtnText}
                    message={decision.message}
                    yesMethod={decision.yesMethod}
                    close={decision.noMethod} 
                />
            }
        </>
    )
}